import React from 'react';
import { Link } from 'react-router-dom';

export default function ProductCard({ product }) {
  return (
    <Link to={`/produit/${product.slug}`} className="group block" data-testid={`product-card-${product.slug}`}>
      <div className="aspect-square bg-white overflow-hidden zoom-parent flex items-center justify-center relative">
        <img
          src={product.images[0]}
          alt={product.name}
          className="w-full h-full object-contain object-center p-1 sm:p-1.5"
          loading="lazy"
        />
        <div className="absolute inset-x-0 bottom-0 py-3 bg-black/85 text-white text-[10px] tracking-[0.32em] uppercase text-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
          Découvrir
        </div>
      </div>
      <div className="mt-5 text-center px-2">
        <div className="font-serif text-lg md:text-xl leading-tight">{product.name}</div>
        <div className="text-sm text-[#666] tracking-[0.15em] mt-1.5">{product.price} €</div>
      </div>
    </Link>
  );
}
